export default defineNuxtPlugin(() => {
  const { canAccessPage, hasRole, hasPermission, hasCapability } = useRights()

  return {
    provide: {
      canAccessPage,
      hasRole,
      hasPermission,
      hasCapability,
    },
  }
})
